import React, { Component } from 'react';

import { Grid, Drawer, ListItem } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import CustomTypo from '../../components/CustomTypo';
import PublicIcon from '@material-ui/icons/Public';
import CallIcon from '@material-ui/icons/Call';
import MailIcon from '@material-ui/icons/Mail';
import Divider from '../../components/Divider'
import DrawerCustom from '../../components/DrawerCustom';

const styles = theme => ({

    item:{
        padding: theme.spacing(4,0,4,0)
    },
    boxItemContent: {
        padding: theme.spacing(4),
        marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer'
    },
});
function ContactUsView(props){
    const renderItem = (contact_us_info,classes) =>{
        if (contact_us_info) {
            var contact_us = contact_us_info;
            var component = [];
            if(contact_us.phone_number)
                component.push(
                    <ListItem className={classes.item}>
                       <Grid item container>
                            <Grid xs={1} item>
                                <CallIcon style={{color: 'rgba(0,0,0,1)'}}/>
                            </Grid>
                            <Grid xs={10} item>
                                <CustomTypo mg_left_xs>{contact_us.phone_number}</CustomTypo>
                                <Divider fullWidth />
                            </Grid>
                        </Grid>
                    </ListItem>

                )
            if(contact_us.email_address)
                component.push(
                    <ListItem className={classes.item}>
                        <Grid item container>
                            <Grid xs={1} item>
                                <MailIcon style={{color: 'rgba(0,0,0,1)'}}/>
                            </Grid>
                            <Grid xs={10} item>
                                <CustomTypo mg_left_xs>{contact_us.email_address}</CustomTypo>
                                <Divider fullWidth/>
                            </Grid>
                        </Grid>
                    </ListItem>
                )
            if(contact_us.website)
                component.push(
                    <ListItem className={classes.item}>
                        <Grid item container>
                            <Grid xs={1} item>
                                <PublicIcon style={{color: 'rgba(0,0,0,1)'}} />
                            </Grid>
                            <Grid xs={10} item>
                                <CustomTypo mg_left_xs>{contact_us.website}</CustomTypo>
                                <Divider fullWidth/>
                            </Grid>
                        </Grid>
                    </ListItem>
                )
            return component;
        }
        return <CustomTypo>{""}</CustomTypo>
    }

    const {classes, t, about_details } = props
    var    contact_us = about_details && about_details.contact_us  ? about_details.contact_us : ""
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={()=>props.onCloseItem('contact_us')}
                title = {t('contact_us_title')}
                enableBack
                children={
                    <Grid item>
                        <Grid xs={12} item className={classes.boxItemContent}>
                            {renderItem(contact_us,classes)}
                        </Grid>
                </Grid>}/>


    </div>
    );
}
export default withStyles(styles)(withTranslation()(ContactUsView));